
export default {
  props: {
    options: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleButtonClick(id) {
      this.$emit("options-clicked", id);
    }
  }
};
